import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { Navigate } from "react-router";



export function Adm({children}){

    const {userFirebase} = useContext(AuthContext);

    if(userFirebase.permission !== 'administrador'){
        return <Navigate to="/dashboard" />
    }

    return children;
}